import shiftRequestDetailsStore from "../../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_SHIFT_NOT_FOUND', function setShiftNotFound(shiftNotFound: boolean) {
    if (shiftRequestDetailsStore) {
        shiftRequestDetailsStore.shiftNotFound = shiftNotFound;
    }
});
